var map = {
	"./": [
		"FYfj",
		"chunk-4553"
	],
	"./api": [
		"2iBx",
		"2iBx"
	],
	"./api.js": [
		"2iBx",
		"2iBx"
	],
	"./index": [
		"FYfj",
		"chunk-4553"
	],
	"./index.vue": [
		"FYfj",
		"chunk-4553"
	],
	"./routes": [
		"sP6e"
	],
	"./routes.js": [
		"sP6e"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "lbo7";
module.exports = webpackAsyncContext;